

export default class Console {

     static getStyle(color) {
        return `background:${color} ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff'`;
    }

     static entity(name, msg) {
        console.log(
            `%c Entity %c ${name} %c ${msg}`,
            Console.getStyle("#35495e"),
            Console.getStyle("#41b883"),
            'background:transparent'
        )
    }
     static debug(name, msg) {
        console.log(
            `%c Entity %c ${name} %c ${msg}`,
            Console.getStyle("#35495e"),
            Console.getStyle("orangered"),
            'background:transparent'
        )
    }
     static info(name, msg) {
        console.log(
            `%c Entity %c ${name} %c ${msg}`,
            Console.getStyle("#35495e"),
            Console.getStyle("#1e90ff"),
            'background:transparent'
        )
    }

}



// WEBPACK FOOTER //
// ./src/test/Console.js